import { request, zujuanrequest } from "../utils/request";

const editqusetionbank = {
  checkExamIsHaveAnswer(data) {
    //获取页面是否答题
    return request({
      method: "POST",
      url: "/api/examManage/examlist/checkExamIsHaveAnswer",
      data
    });
  },
  GetSavepaperList(data) {
    //获取所有已经新增设置好的数据
    return request({
      method: "POST",
      url: "/api/exammanage/examlist/GetSavepaperList",
      data
    });
  },
  // 难易度编辑获取第三步回显数据
  getFeedbackStyle(data) {
    //获取各类题型总数
    return request({
      method: "POST",
      url: "/api/paperManage_difflevel/editPaper/getStyle/getStyle",
      data
    });
  },
  getPaperStyle(data) {
    //获取各类题型总数
    return request({
      method: "POST",
      url: "/api/papermanage/paperStyleApi/getPaperStyle",
      data
    });
  },
  getPaperJSON(data) {
    //获取各类题型具体内容
    return request({
      method: "POST",
      url: "/api/papermanage/papereditapi/getPaperJSON",
      data
    });
  },
  // 获取难易度回显题目
  getStyleTest(data) {
    return request({
      method: "POST",
      url: "/api/paperManage_difflevel/editPaper/getPaper/getStyleTest",
      data
    });
  },
  MoveTest(data) {
    //获取各类题型具体内容
    return request({
      method: "POST",
      url: "/api/papermanage/MoveTest/MoveTest",
      data
    });
  },
  DeleteTest(data) {
    //删除试卷
    return request({
      method: "POST",
      url: "/api/paperManage/deleteTestApp/delete/Test",
      data
    });
  },
  facilityDeleteTest(data) {
    //删除试卷 ----> 难易度组卷
    return request({
      method: "POST",
      url: "/api/paperManage_difflevel/editPaper/delete/deleteTest",
      data
    });
  },
  replaceTest(data) {
    //删除试卷
    return request({
      method: "POST",
      url: "/api/papermanage/paperEditApi/replaceTest",
      data
    });
  },
  addTest(data) {
    //添加新的试题试卷
    return request({
      method: "POST",
      url: "/api/papermanage/paperAddTest/addTest",
      data
    });
  },
  deletestyle(data) {
    //删除全部试卷
    return request({
      method: "POST",
      url: "/api/paperManage/deleteTestApp/delete/Style",
      data
    });
  },
  facility_deletestyle(data) {
    // 删除题型 ======> 难易度
    return request({
      method: "POST",
      url: "/api/paperManage_difflevel/editPaper/delete/deleteStyle",
      data
    });
  },
  Savestudent(data) {
    return zujuanrequest({
      method: "POST",
      url: "/api/exammanage/examlist/Savestudent",
      data
    });
  },
  updatePaper(data) {
    return zujuanrequest({
      method: "POST",
      url: "/api/paperManage/createPaperApi2_Manual/updatePaper",
      data
    });
  },
  overridePaper(data) {
    return request({
      method: "POST",
      url: "/api/overridePaper/updatePaper/addTest",
      data
    });
  },
  createPaper(data) {
    return zujuanrequest({
      method: "POST",
      url: "/api/ProportionPaper/CreatePaper_p/createPaper",
      data
    });
  },
  addTestManual(data) {
    return request({
      method: "POST",
      url: "/api/papermanage/paperEditApi/addTestManual",
      data
    });
  },
  // 难易度手动添题
  addTestFacility(data) {
    return request({
      method: "POST",
      url: "/api/paperManage_difflevel/editPaper/add/addTest",
      data
    });
  },
  SavePaper(data) {
    return zujuanrequest({
      method: "POST",
      url: "/api/overridePaper/SavePaper/SavePaper",
      data
    });
  },
  // 智能添题编辑回显
  Query(data) {
    return request({
      method: "POST",
      url: "/api/customTest/ImportSingleTest/Query",
      data
    });
  },
  //统一模式下的数据保存。
  savetongyi(data) {
    return request({
      method: "POST",
      url: "/api/papermanage/paperstylemodifyapi/modifystyle",
      data
    });
  },
  // 是否有人脸识别权限
  checkVip(data) {
    return request({
      method: "POST",
      url: "/api/faceAuth/faceAuthManager/checkVip",
      data
    });
  },
  // 更换试题接口 ===> 难易度组卷
  facilityReplaceTest(data) {
    return request({
      method: "POST",
      url: "/api/paperManage_difflevel/editPaper/replace/replaceTest",
      data
    });
  },
  // 难易度编辑保存试卷
  editSaveTest(data) {
    return request({
      method: "POST",
      url: "/api/paperManage_difflevel/editPaper/save/saveTest",
      data
    });
  },
  // 组卷添加考生===》批量导入
  importExcelAndCreateExam(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageStudent/importExcelAndCreateExam",
      data
    });
  }
};

export default editqusetionbank;
